<template>
  <div v-cloak id="app">  
    <router-view></router-view>
  </div>
</template>

<script>
require('./style/iconfont/iconfont.css')

export default {
  name: 'app'
}
</script>

<style lang="scss">
  @import "./style/override";
  @import "./style/common";
</style>



// WEBPACK FOOTER //
// src/App.vue